<div class="leveling-screen">
  <!-- Today's apps strip (horizontal) -->
  <div class="today-strip" *ngIf="todayApps.length">
    <div
      class="today-app"
      *ngFor="let app of todayApps; trackBy: trackByApp"
      [ngClass]="'state-' + app.state"
      [attr.data-cy]="'today-app-' + (app.param || app.name)"
    >
      <img class="today-app__img" [src]="app.imageUrl" [alt]="app.name" />
      <img
        *ngIf="app.state === 'completed'"
        class="today-app__check"
        src="assets/images/checkmark.png"
        alt="Completed"
      />
    </div>
  </div>

  <!-- Header -->
  <div
    class="headline"
    [ngClass]="{
      'headline--celebrate': headerText !== 'Great Work!'
    }"
  >
    {{ headerText }}
  </div>
  <div class="subhead">
    {{ subtext }}
  </div>

  <!-- Score row -->
  <div class="score-row" *ngIf="App">
    <div class="score-left">
      <div class="score-label">
        <span>Game Score</span>
        <i class="fa-solid fa-circle-info" (click)="seeHelper()"></i>
      </div>
      <div class="score-value" [ngClass]="{ 'score-value--shiny': isNewHighScore }">
        {{ getScoreText() }}
      </div>
    </div>

    <div class="score-right">
      <app-button
        *ngIf="Game === appenums.HappyPlace"
        text="See Averages"
        (click)="seeAverages()"
        backgroundColor="white"
      ></app-button>
      <app-button
        *ngIf="Game !== appenums.HappyPlace"
        text="See Leaderboard"
        (click)="seeLeaderboard()"
        backgroundColor="white"
      ></app-button>
    </div>
  </div>

  <!-- Actions -->
  <div class="actions" *ngIf="App">
    <app-button text="Done" (click)="done()"></app-button>
    <app-button
      *ngIf="phaser"
      text="Back To Game"
      data-cy="retry"
      (click)="backToGame()"
      backgroundColor="white"
    ></app-button>
    <app-button
      *ngIf="!phaser"
      text="Retry"
      data-cy="retry"
      (click)="retry()"
      backgroundColor="white"
    ></app-button>
  </div>
</div>







